import { Form, message } from 'antd';
import { useState } from 'react';
import { alternativePhonesToArrayOfObjects } from '../components/alternative-phones/alternative-phones.utils';
import { messages } from '../data/data';
import { registerUser } from '../services/services';
import { formatCUITCUIL } from '../utils/utils';

const error = msg => message.error(msg, 5);

const useRegisterForm = (onOkRegister) => {

    const [form] = Form.useForm();
    const [isLoadingForm, setIsLoadingForm] = useState(false);

    const register = ({ insuredPerson, alternativePhones, formValues }) => {

        const { name, isUser, cuit } = insuredPerson;

        setIsLoadingForm(true);

        const {
            email,
            phoneCode, phoneNumber, phoneCompany,
            password, confirmPassword,
            ...altPhonesFormValues } = formValues;

        const altPhonesRequest = alternativePhonesToArrayOfObjects(alternativePhones, altPhonesFormValues)

        registerUser({
            userName: name,
            cuit: formatCUITCUIL(cuit),
            email,
            phone: phoneCode + phoneNumber,
            phoneCompany,
            alternativePhones: altPhonesRequest,
            password
        })
            .then(axiosResponse => {
                const { data } = axiosResponse.data
                const json_response = JSON.parse(data)

                setIsLoadingForm(false);

                if (json_response.Id === "-1")
                    error(json_response.ErrorMessage);
                else {
                    const succesMsg = isUser ? messages.update : messages.create
                    onOkRegister(succesMsg)
                }
            })
            .catch(err => {
                setIsLoadingForm(false);
                error(messages.error);
            })
    }

    return {
        form,
        isLoadingForm,
        register
    }

}

export default useRegisterForm